export type { Member } from './entities/members';
export {
  DocGrantedUsersService,
  type GrantedUser,
} from './services/doc-granted-users';
export { GuardService } from './services/guard';
export { MemberSearchService } from './services/member-search';
export { WorkspaceMembersService } from './services/members';
export { WorkspacePermissionService } from './services/permission';
export { WorkspaceTeamService } from './services/teams';
export {
  type DocPermissionActions,
  type WorkspacePermissionActions,
} from './stores/guard';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud/services/workspace-server';
import { DocScope, DocService } from '../doc';
import {
  WorkspaceLocalState,
  WorkspaceScope,
  WorkspaceService,
  WorkspacesService,
} from '../workspace';
import { WorkspaceMembers } from './entities/members';
import { WorkspacePermission } from './entities/permission';
import { DocGrantedUsersService } from './services/doc-granted-users';
import { GuardService } from './services/guard';
import { MemberSearchService } from './services/member-search';
import { WorkspaceMembersService } from './services/members';
import { WorkspacePermissionService } from './services/permission';
import { DocGrantedUsersStore } from './stores/doc-granted-users';
import { GuardStore } from './stores/guard';
import { MemberSearchStore } from './stores/member-search';
import { WorkspaceMembersStore } from './stores/members';
import { WorkspacePermissionStore } from './stores/permission';
import { WorkspaceTeamService } from './services/teams';
import { WorkspaceTeamsStore } from './stores/teams';
import { WorkspaceTeams } from './entities/teams';
import { TeamSearchService } from './services/team-search';
import { DocPermission } from './entities/doc-permission';
import { MyTeamIds } from './entities/my-team-ids';

export function configurePermissionsModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspacePermissionService, [
      WorkspaceService,
      WorkspacesService,
      WorkspacePermissionStore,
    ])
    .store(WorkspacePermissionStore, [
      WorkspaceServerService,
      WorkspaceLocalState,
    ])
    .entity(WorkspacePermission, [WorkspaceService, WorkspacePermissionStore])
    .entity(DocPermission, [WorkspacePermissionStore, WorkspaceService])
    .service(WorkspaceMembersService, [WorkspaceMembersStore, WorkspaceService])
    .store(WorkspaceMembersStore, [WorkspaceServerService])
    .entity(WorkspaceMembers, [WorkspaceMembersStore, WorkspaceService])
    .service(MemberSearchService, [MemberSearchStore, WorkspaceService])
    .store(MemberSearchStore, [WorkspaceServerService])
    .service(GuardService, [
      GuardStore,
      WorkspaceService,
      WorkspacePermissionService,
    ])
    .store(GuardStore, [WorkspaceService, WorkspaceServerService])
    .service(WorkspaceTeamService, [WorkspaceTeamsStore, WorkspaceService])
    .store(WorkspaceTeamsStore, [WorkspaceServerService])
    .entity(WorkspaceTeams, [WorkspaceTeamsStore, WorkspaceService])
    .entity(MyTeamIds, [WorkspaceTeamsStore, WorkspaceService])
    .service(TeamSearchService, [WorkspaceTeamsStore, WorkspaceService])
  framework
    .scope(WorkspaceScope)
    .scope(DocScope)
    .service(DocGrantedUsersService, [
      DocGrantedUsersStore,
      WorkspaceService,
      DocService,
    ])
    .store(DocGrantedUsersStore, [WorkspaceServerService]);
}
